module.exports = __webpack_public_path__ + "img/screen-write-dark-es.6f16f095.png";